const types = {
  APPOINTMENTS: '/appointments',
  CLIENTS: '/clients',
  CONSULTATION_ADD_PARTICIPANT: '/addParticipant',
  CONSULTATION_REASSIGN: '/consultationReassign',
  CONSULTATION_RECORDINGS: '/consultationRecordings',
  CONSULTATION_OPTIONS: '/consultationOptions',
  CONSULTATION: '/consultation',
  CONSULTATION_START: '/consultationStart',
  CONSULTATIONS: '/consultations',
  CLIENT_DETAILS: '/clientDetails',
  DYNAMIC_LINKS: '/dynamic',
  EMG: '/emg',
  EMG_VIDEO: '/i_s',
  FRONT_DESK_CONSULTATIONS: '/frontDeskConsultations',
  FRONT_DESK_HOME: '/frontDeskHome',
  HOME: '/home',
  INSTANT_COMPLETED: '/completedInstant',
  INSTANT_HELP: '/help',
  INSTANT_HOME: '/instant',
  INSTANT_LANDING: '/',
  INSTANT_SETTINGS: '/settings',
  INSTANT_RECORDINGS: '/recordings',
  INSTANT_SIGN_UP: '/signUp',
  INSTANT_VALIDATION: '/validation',
  INSTANT_VIDEO: '/vs',
  LOCATION_CLIENTS: '/locationClients',
  LOCATION_PROVIDERS: '/locationProviders',
  MY_ACCOUNT: '/myAccount',
  PRACTICE: '/practice',
  PRACTICE_PLANS: '/practicePlans',
  PRACTICE_ADMINS_EDIT: '/editPracticeAdmins',
  PRACTICE_ALERT_EDIT: '/editAlerts',
  PRACTICE_INFO_EDIT: '/editPracticeInfo',
  PRACTICE_FRONT_DESK_EDIT: '/editFrontDeskAccount',
  PRACTICE_BANK_EDIT: '/editBankInfo',
  PRACTICE_LOCATION_EDIT: '/editLocation',
  PRACTICE_LOCATION_DETAILS: '/locationDetails',
  PRACTICE_NOTIFICATION_PREFERENCES: '/practiceNotificationPreferences',
  PRACTICE_STAFF_MEMBER_DETAILS: '/staffMemberDetails',
  PRACTICE_ASSIGN_CLIENT: '/assignClient',
  SETTINGS: '/settings',
  SIGN_IN: '/',
  SIGN_UP: '/signUp',
  STAFF: '/staff',
  STRIPE_REDIRECT: '/validation_completed',
  SUBSCRIPTION_DETAILS: '/subscription_details',
  SWITCH_ACCOUNTS: '/switchAccount',
  USER_FORGOT_PASSWORD: '/forgotPassword',
  USER_SIGN_IN_CODE: '/signInCode',
  USER_PROFILE_EDIT: '/editUserProfile',
  VIDEO_CALL: '/videoCall',
}

export default types;
